export default __webpack_public_path__ + "static/media/COMM_NON_VERBAL.9623ba77.pdf";